<template>
  <div class="common-form" :style="{ background: `url('${formConfig.backgroundImg}') center center no-repeat` }">
    <img :src="formConfig.bannerImg" style="width:100%" />
    <div style="position:relative">
      <div class="form-content">
        <div v-for="(item, index) in formConfig.fields"
          :style="{ 'margin-bottom': index === formConfig.fields.length - 1 ? '100px' : '0px' }" :key="index">
          <div class="form-label">{{ item.name }}<span v-if="item.required">*</span></div>
          <div class="input-box" style="position:relative" v-if="item.type === 'verifyCode'">
            <input @blur="inputClick('INPUTBOX_INPUT', item)" @click="inputClick('INPUTBOX_CLICK', item)"
              :placeholder="item.placeholder || ''"
              :oninput="`if(value.length>${item.maxLength})value=value.slice(0,${item.maxLength})`" type="number"
              v-model.trim="formData[item.field]" />
            <div @click="sendCode(item)" :class="{ 'send-code': true, 'disabled': getCodeTime > 0 }">{{ getCodeTime > 0 ?
              `${getCodeTime}s后重新发送` : '获取验证码'
            }}</div>
          </div>
          <div v-else class="input-box">
            <input @blur="inputClick('INPUTBOX_INPUT', item)" @click="inputClick('INPUTBOX_CLICK', item)"
              :placeholder="item.placeholder || ''"
              :oninput="`if(value.length>${item.maxLength})value=value.slice(0,${item.maxLength})`" :type="item.type"
              v-model.trim="formData[item.field]" :maxlength="item.maxLength" />
          </div>
        </div>
        <div class="agree-box" v-if="formConfig.agreements && formConfig.agreements.length > 0">
          <van-checkbox icon-size="18px" style="margin-right:4px" checked-color="#fdb017" v-model="checked"
            shape="square"></van-checkbox>
          我同意<span v-for="(item, index) in formConfig.agreements" :key="index" @click.stop="openLink(item.link)">{{
            item.name
          }}</span>
        </div>
        <div @click="submit" :class="{ 'normal': true, 'active': completeForm }">{{ formConfig.submitMsg || '提交' }}</div>
        <div class="tip" v-if="formConfig.tipMsg">{{ formConfig.tipMsg }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendPhoneVerifyCode } from "@/axios/PublicLink/index";
import { submitForm } from "@/axios/applyForm/commonForm.js";
const validPhone = (phone) => /^1[3-9]\d{9}$/.test(phone);
export default {
  props: ["formConfig", "trackData"],
  data() {
    return {
      formData: {},
      checked: false,
      getCodeTime: 0,
      submitting: false,
    };
  },
  computed: {
    completeForm() {
      const { fields } = this.formConfig;
      return fields.every(v => !v.required || this.formData[v.field])
    }
  },
  watch: {
    checked() {
      yxczxy.track('BUTTON_CLICK', { ...this.trackData, buttonName: '我同意' });
    }
  },
  methods: {
    inputClick(key, data) {
      yxczxy.track(key, { ...this.trackData, inputboxName: data.name });
    },
    // 打开协议
    openLink(link) {
      window.open(link);
    },
    // 发送验证码
    sendCode({ phoneField = 'phone' }) {
      if (this.getCodeTime > 0) {
        return;
      }
      yxczxy.track('BUTTON_CLICK', { ...this.trackData, buttonName: '获取验证码' });
      const phone = this.formData[phoneField];
      if (!phone) {
        return this.$toast('请输入手机号');
      }
      if (!validPhone(phone)) {
        return this.$toast('手机号格式不正确');
      }
      sendPhoneVerifyCode({ phone });
      this.getCodeTime = 60;
      this.timer = setInterval(() => {
        this.getCodeTime = this.getCodeTime - 1
        if (this.getCodeTime < 0) {
          // 倒计时结束，重置时间器clearInterval(this.timer)
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 校验参数是否合法
    verifyFormData() {
      let result = true;
      const { fields } = this.formConfig;
      const formData = this.formData;
      for (var i = 0; i < fields.length; i++) {
        const { name, field, show, regx } = fields[i];
        // 如果该表单项显示，并且输入了值，并且存在正则，则需要校验正则
        if (show && formData[field] && regx && !new RegExp(regx).test(formData[field])) {
          result = false;
          this.$toast(`${name}不合法，请重新输入`)
          break;
        }
      }
      return result;
    },
    // 提交
    submit() {
      if (!this.completeForm || this.submitting) {
        return;
      }
      if (this.formConfig.agreements && this.formConfig.agreements.length && !this.checked) {
        return this.$toast(`请同意${this.formConfig.agreements.map(v => v.name).join('、')}`);
      }
      // 表单校验不通过返回
      if (!this.verifyFormData()) {
        return
      }
      if (this.timeSend) {
        clearTimeout(this.timeSend);
      }
      this.timeSend = setTimeout(() => {
        yxczxy.track('BUTTON_CLICK', { ...this.trackData, buttonName: this.formConfig.submitMsg, ...this.formData });
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        this.submitting = true;
        const params = {
          ...this.$route.query,
          sourceUrl: window.location.href,
          formData: { ...this.$route.query, ...this.formData }
        }
        submitForm(params).then(res => {
          this.$toast.clear();
          if (res.errcode !== 0) {
            return this.$toast({ message: res.errmsg, duration: 3000 });
          }
          if (this.formConfig.hasRecommendedGuide) {
            this.$router.push({
              path: '/commonFormDetail',
              query: this.$route.query
            });
          } else {
            this.$toast({ message: '提交成功', duration: 3000 });
            this.formData = {};
            this.checked = false;
            this.getCodeTime = 0;
          }
        }).catch(() => {
          this.$toast.clear();
          this.$toast({ message: '网络错误请重试', duration: 3000 })
        }).finally(() => {
          this.submitting = false;
        });
      }, 500);
    }
  },
};
</script>

<style lang="scss" scoped>
.common-form {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  background-size: 100% 100%;
}

.form-content {
  position: absolute;
  left: 14px;
  top: -30px;
  width: calc(100vw - 28px);
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 2px 5px 0px #f8f1ee;
  border-radius: 10px;
  padding: 25px;

  .input-box {
    border-radius: 4px;
    border: 1px solid #eaeaea;
    margin-bottom: 20px;
  }

  input {
    height: 40px;
    width: 100%;
    border: none;
    box-sizing: border-box;
    padding-left: 10px;
    outline: none;
    background: transparent;
  }

  .agree-box {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #4b4b4b;

    span {
      color: #3d7eb2;
    }
  }


  .normal {
    width: 100%;
    height: 35px;
    background-color: #e9e8ed;
    font-size: 14px;
    color: #737277;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;

    &.active {
      background: #fdb017;
      color: #fff;
    }
  }

  .send-code {
    position: absolute;
    right: 8px;
    top: 5px;
    padding: 6px 8px;
    border-radius: 3px;
    background: #f96720;
    color: #fff;
    font-size: 12px;

    &.disabled {
      color: #737277;
      background-color: #e9e8ed;
    }
  }

  .tip {
    font-size: 12px;
    color: #989898;
  }
}

.form-label {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #1f1f20;
  margin-bottom: 8px;
  position: relative;

  span {
    color: red;
    padding-left: 5px;
  }
}
</style>
